import { api } from './client.js';

export type RoomDb = {
  id: string;
  tenantId: string;
  roomTypeId: string;
  code: string;
  floor: string;
  building: string;
  status: 'free' | 'reserved' | 'occupied' | 'dirty' | 'out_of_order';
  knxConfig: Record<string, unknown>;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
};

export type BookingDto = {
  id: string;
  tenantId: string;
  roomId: string | null;
  roomTypeId: string;
  publicCode: string;
  guestId: string;
  /** Nome ospite (HM-131 cluster 13: aggiunto al response GET /bookings). */
  guestName?: string | null;
  service: 'day_use' | 'overnight';
  status:
    | 'pending'
    | 'confirmed'
    | 'checked_in'
    | 'checked_out'
    | 'cancelled'
    | 'no_show'
    | 'conflict_unresolved';
  channel: 'walk_in' | 'phone' | 'online' | 'ota';
  startAt: string;
  endAt: string;
  totalAmount: string;
  extraAmount: string;
  paidAmount: string;
  note: string | null;
  /**
   * HM-451 fix overstay: somma extras LIVE (extra_hours_log non-removed).
   * Aggiornato dal worker `extra-hours-calculator` ogni 60s. Per booking
   * checked_in che hanno sforato end_at + buffer, cumula le ore extra fino
   * a overnight_price per ogni ciclo di 24h.
   */
  extraSumLive?: string;
  /** Total dovuto = totalAmount + extraSumLive (computed lato server). */
  currentTotalDue?: string;
  /**
   * QA sweep 2026-07-22: campi gia' presenti nel response GET /bookings
   * (serializeBooking spreada l'intera row) ma non tipizzati finora.
   * checkedInAt/checkedOutAt = ISO string quando il check-in/out e'
   * EFFETTUATO (timestamp FSM), null altrimenti.
   */
  extraHours?: number;
  checkedInAt?: string | null;
  checkedOutAt?: string | null;
};

export async function fetchRooms(): Promise<{ rooms: RoomDb[] }> {
  return api('/rooms');
}

// HM-318.r cluster 15.4: endpoint "Assegna Camera" piano-first.
export type NextAvailableRoom = {
  roomId: string;
  roomCode: string;
  building: string;
  floor: string;
  totalAvailable: number;
};

export async function fetchNextAvailableRoom(): Promise<NextAvailableRoom> {
  return api('/rooms/next-available');
}

export async function fetchBookingsWindow(params: {
  from: string;
  to: string;
}): Promise<{ bookings: BookingDto[] }> {
  const q = new URLSearchParams({ from: params.from, to: params.to });
  return api(`/bookings?${q.toString()}`);
}
